import { render, staticRenderFns } from "./OrgName.vue?vue&type=template&id=7640742a&"
import script from "./OrgName.vue?vue&type=script&lang=js&"
export * from "./OrgName.vue?vue&type=script&lang=js&"
import style0 from "./OrgName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports